// extracted by mini-css-extract-plugin
export default {"modalOverlay":"Modal_modalOverlay__qBRQV","active":"Modal_active__-yLpX","modalClose":"Modal_modalClose__ROekx"};